import { useEffect } from 'react';
import { t } from 'i18next';
import useUserQuery from '../../../components/api/queries/useUserQuery';
import { useAdPopcorn } from '../hooks/useAdPopcorn';
import { ReactComponent as BlueGiftFill } from '../../../icons/blue.gift.svg';
import { ReactComponent as GradientHeartIcon } from '../../../icons/likeGradientShape.svg';

interface EmptyHeartCardProps {
  openChargeBottomSheet: () => void;
}

const EmptyHeartCard = ({ openChargeBottomSheet }: EmptyHeartCardProps) => {
  const { setUserId, openOfferwall } = useAdPopcorn();

  const user = useUserQuery();

  useEffect(() => {
    setUserId(user?.userId);
  }, [user, setUserId]);

  return (
    <div className="bg-background-elevated rounded-[20px] px-[16px] pt-[24px] pb-[22px] shadow-[0_0_3px_0_rgba(0,0,0,0.05),_0_0_12px_0_rgba(0,0,0,0.08)] ml-[12px] mr-[16px] mt-[30px]">
      <div className="flex flex-col items-center gap-[14px]">
        <p className="text-[17px] font-semibold text-text-main-lv1 leading-[20px]">
          {t('EmptyHeartCard.title')}
        </p>
        <p className="text-[15px] font-medium text-text-main-lv4 leading-[18px] text-center whitespace-pre-line">
          {t('EmptyHeartCard.description')}
        </p>
      </div>
      <div className="flex items-center justify-center gap-[9px] mt-[26px]">
        <button
          type="button"
          className="flex items-center gap-[4px] w-[143px] justify-center pl-[14px] pr-[15px] rounded-full pt-[12px] pb-[10px] border border-[rgba(255,255,255,0.60)] shadow-[0_4px_10px_0_rgba(0,0,0,0.04),_0_0_24px_0_rgba(255,255,255,0.30)_inset]"
          style={{
            background:
              'linear-gradient(126deg, #C6E1FF 19.1%, rgba(198, 225, 255, 0.20) 37.98%, rgba(198, 225, 255, 0.40) 43.65%, rgba(198, 225, 255, 0.60) 49.32%, rgba(198, 225, 255, 0.10) 79.54%)'
          }}
          onClick={openOfferwall}
        >
          <BlueGiftFill width={18} height={18} />
          <p
            className="text-[14px] font-semibold leading-[17px]"
            style={{
              background: 'linear-gradient(136deg, #15CCCB 1.21%, #4987FF 50.69%, #8B1CFA 101.7%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}
          >
            {t('EmptyHeartCard.getFreeHeart')}
          </p>
        </button>
        <button
          type="button"
          className="flex items-center justify-center gap-[4px] py-[11px] w-[143px] border border-separator1 rounded-full"
          onClick={openChargeBottomSheet}
        >
          <GradientHeartIcon width={18} height={18} />
          <p className="text-[14px] font-semibold text-text-main-lv2 leading-[17px]">
            {t('EmptyHeartCard.purchaseHeart')}
          </p>
        </button>
      </div>
    </div>
  );
};

export default EmptyHeartCard;
